const SFCC_REFERRAL_SOURCE_CODE_KEY = 'SFCCReferralSourceCode';

export const getSFCCReferralSourceCode = (): string | undefined => {
  return sessionStorage.getItem(SFCC_REFERRAL_SOURCE_CODE_KEY) || undefined;
};

export const saveSFCCReferralSourceCode = (sourceCode: string): void => {
  sessionStorage.setItem(SFCC_REFERRAL_SOURCE_CODE_KEY, sourceCode);
};

export const removeSFCCReferralSourceCode = (): void => {
  sessionStorage.removeItem(SFCC_REFERRAL_SOURCE_CODE_KEY);
};
